import { Dispatch, SetStateAction, useEffect } from 'react'
import { BreadType } from 'types/bread'
import { filterBreadsByCategory, filterBreadsByKeyword, filterBreadsByPage } from 'lib/filter'
import { StockType } from 'types/stock'
import { CategoryType } from 'types/category'

const useInitBreadList = (params: {
  breads: BreadType[]
  categories: CategoryType[]
  categoryName: string
  keyword: string
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
  page: 'released' | 'unreleased'
  stocks: StockType[]
}) => {
  const { breads, categories, categoryName, keyword, setBreadList, page, stocks } = params
  return useEffect(() => {
    if (!stocks || !breads || !page) return
    // 販売中か未販売かでフィルタリング
    let _breads: BreadType[] = filterBreadsByPage(page, breads, stocks)
    // カテゴリが指定されていればフィルタリング
    if (categoryName !== '') {
      _breads = filterBreadsByCategory(categoryName, categories, _breads)
    }
    // 検索キーワードが入力されていればフィルタリング
    if (keyword !== '') {
      _breads = filterBreadsByKeyword(keyword, _breads)
    }
    setBreadList([..._breads])
  }, [breads, page, stocks])
}

export default useInitBreadList
